var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompare = function SvgCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 16.937 9.256.034-2.194 2.233a1.001 1.001 0 1 0 1.426 1.4l2.239-2.279c.163-.163.39-.413.624-.675a2.59 2.59 0 0 0 0-3.429 17 17 0 0 0-.618-.67l-2.245-2.28a1 1 0 0 0-1.426 1.4l2.25 2.29.009.01L1 14.937a1 1 0 1 0 0 2M15.208 3a1 1 0 0 1 .73 1.67l-2.25 2.29-.008.012L23 6.937a1 1 0 0 1 0 2l-9.256.035 2.194 2.232a1 1 0 0 1 .016 1.442 1 1 0 0 1-1.441-.042l-2.24-2.279a18 18 0 0 1-.624-.675 2.59 2.59 0 0 1 0-3.428c.233-.263.462-.514.619-.671l2.245-2.28A1 1 0 0 1 15.208 3"
  })));
};
export default SvgCompare;